import {
  PLAYED_COUNT_FILTER_MAX,
  normalizePlayedCountRange,
  sanitizePlayedCountBound,
} from "../constants/registerFilters";

export { PLAYED_COUNT_FILTER_MAX, sanitizePlayedCountBound, normalizePlayedCountRange };

export function getWordPlayedCount(word) {
  const count = word?.stats?.gameCount;
  return typeof count === "number" && count >= 0 ? count : 0;
}

export function isPlayedCountRangeFilterActive(min, max) {
  return Boolean(sanitizePlayedCountBound(min) !== "" || sanitizePlayedCountBound(max) !== "");
}

export function wordMatchesPlayedCountRange(word, minRaw, maxRaw) {
  const { min, max } = normalizePlayedCountRange(minRaw, maxRaw);
  if (min === "" && max === "") return true;

  const count = getWordPlayedCount(word);
  if (min !== "" && count < Number(min)) return false;
  if (max !== "" && count > Number(max)) return false;
  return true;
}
